import axiosClient from "./axiosClient";

const orderApi = {
  SearchCustomerOrders: (customerId, page, pageSize, orderType) => {
    const data = {
      customerId: customerId,
      pageNumber: page > 0 ? page + 1 : 1,
      pageSize: pageSize,
      orderType,
    };
    return axiosClient.post(`/orders/search`, data, {
      withCredentials: true,
    });
  },
  createOrder: (
    orderId,
    orderType,
    priceListId,
    isExtra,
    note,
    startTime,
    customerId,
    createByUserId
  ) => {
    return axiosClient.post(
      `/orders/create-order`,
      {
        orderId: orderId,
        orderType: orderType,
        priceListId: priceListId,
        isExtra: isExtra,
        note: note,
        startTime: startTime,
        customerId: customerId,
        createByUserId: createByUserId,
      },
      {
        withCredentials: true,
      }
    );
  },
  getLastOrder: (customerId, orderType) => {
    const data = {
      customerId: customerId,
      orderType: orderType,
    };
    return axiosClient.post(`/orders/get-last-order/`, data, {
      withCredentials: true,
    });
  },
  getOrderInfor: (orderId) => {
    return axiosClient.get(`/orders/get-order-infor/${orderId}`, {
      withCredentials: true,
    });
  },
  checkPaymentStatus: (orderId) => {
    return axiosClient.get(`/orders/check-payment-status/${orderId}`, {
      withCredentials: true,
    });
  },
  handlePaymentApproval: (orderId, userId) => {
    return axiosClient.put(
      `/orders/payment-approval`,
      {
        orderId: orderId,
        userId: userId,
      },
      {
        withCredentials: true,
      }
    );
  },
  handleCancelOrder: (orderId, userId) => {
    return axiosClient.post(
      `/orders/cancel-order`,
      {
        orderId: orderId,
        userId: userId,
      },
      {
        withCredentials: true,
      }
    );
  },
};

export default orderApi;
